import { useEffect } from "react";

export default function FormSponsor() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://paperform.co/__embed.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div data-paperform-id="fincomp-sponsor"></div>;
}
